/**
 * @file useSubscriptionDetail
 * @description 拉取订阅管理列表（GET /payment/order/detail）：当前生效中 + 待生效
 * - 仅登录后启用
 * - staleTime 设为 0，每次弹窗重新挂载都会请求最新数据
 */

import {useQuery} from '@tanstack/react-query';
import {getPaymentOrderDetail} from '@/services/commerce/order';
import type {CurrentSubscription, SubscriptionCardItem} from '@/services/commerce/order/interface';
import {useAuthStore} from '@/store/useAuthStore';

export const subscriptionDetailKeys = {
    all: ['commerce.subscriptionDetail'] as const,
};

export interface UseSubscriptionDetailResult {
    currentSubscription: CurrentSubscription | null | undefined;
    pendingList: SubscriptionCardItem[] | undefined;
    isLoading: boolean;
    isError: boolean;
}

export function useSubscriptionDetail(enabled: boolean = true): UseSubscriptionDetailResult {
    const isLogin = useAuthStore((state) => state.isLogin);

    const {data, isLoading, isError} = useQuery({
        queryKey: subscriptionDetailKeys.all,
        queryFn: () => getPaymentOrderDetail(),
        enabled: isLogin && enabled,
        staleTime: 0,
        gcTime: 30 * 60 * 1000,
        retry: 1,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
    });

    return {
        currentSubscription: data?.currentSubscription,
        pendingList: data?.pendingList,
        isLoading,
        isError,
    };
}
